/* eslint-disable ember/classic-decorator-hooks, ember/classic-decorator-no-classic-methods, ember/no-controller-access-in-routes, ember/no-get, warp-drive/no-legacy-request-patterns */
import Route from '@ember/routing/route';

import { service } from '@ember/service';
import { isEmpty } from '@ember/utils';
import { hash } from '@linc-technologies/linced-common/utils/promise';
import moment from 'moment';

export default class ListBuilderRoute extends Route {
  // Services
  @service
  router;

  @service
  session;

  @service
  store;

  model() {
    let year = moment().format('YYYY');
    return hash({
      groups: this.store.query('group', {
        schoolId: this.get('session.activeSchool'),
        year,
      }),
      fieldGroups: this.store.findAll('people-schema/group', {
        include: 'fields',
      }),
      // Resolved to a plain array: the {{reverse}} template helper calls
      // A() on it, which throws on ember-data's live-array proxy.
      terms: this.store.findAll('term').then((terms) => terms.slice()),
    });
  }

  init() {
    super.init(...arguments);

    // Reset field selection when transitioning to List Builder from anywhere other than a List.
    this.router.on('routeWillChange', (transition) => {
      let from = transition.from;
      if (
        isEmpty(from) ||
        !transition.to.find((route) => route.name === this.routeName)
      ) {
        // Not transitioning from anywhere, or not transitioning to this route.
        // We're not interested in this transition.
        return;
      }
      if (
        !from.find(
          (route) =>
            route.name === this.routeName || route.name === 'admin.list',
        )
      ) {
        // Transitioning to List Builder from somewhere other than a List.  Reset selection if controller exists.
        if (!isEmpty(this.controller)) {
          this.controller.clear();
        }
        // Also reset person selections
        let listController = this.controllerFor('admin.list');
        if (!isEmpty(listController)) {
          listController.clearSelection();
        }
      }
    });
  }

  setupController(controller) {
    let isFirstEntry = isEmpty(controller.model);
    super.setupController(...arguments);
    if (isFirstEntry) {
      controller.clear();
    }
  }
}
